// extracted by mini-css-extract-plugin
module.exports = {"text-wrapper":"cvps_text-wrapper__to4no","trustpilot-wrapper":"cvps_trustpilot-wrapper__NN32W"};